import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

export const PreOrderWrap = styled.div`
  display: flex;
  padding: 16px;

  > div {
    &:first-child {
      font-size: 14px;
      font-weight: 600;
      color: ${vars.v3Color.gray500};
    }

    &:last-child {
      flex: 1;
      margin-left: 40px;
      margin-top: -6px;
    }
  }
`;

export const PreOrderLabel = styled.span`
  display: inline-block;
  vertical-align: top;
  color: #3990f1;
  font-weight: 600;
  font-size: 9px;
  border-radius: 2px;
  padding: 4px 6px;
  background: #e8f3ff;
`;

export const ShippingInfo = styled.div`
  display: flex;
  align-items: center;
`;

export const ShippingDetail = styled.div`
  margin-top: 4px;

  p {
    font-size: 14px;
    font-weight: 500;
    color: ${vars.v3Color.gray900};
    margin-bottom: 3px;

    b {
      color: #3990f1;
      font-weight: 500;
    }
  }
`;

export const Deadline = styled.div`
  color: ${vars.v3Color.gray900};
  font-weight: 400;
  font-size: 13px;
`;

export const ShippingFee = styled.p`
  color: ${vars.v3Color.gray900};
  font-weight: 400;
  font-size: 14px;

  small {
    font-size: 14px;
    font-weight: 400;
    color: ${vars.v3Color.gray400};
  }
`;

export const Divider = styled.div`
  margin: 0 5px;
  width: 1px;
  height: 12px;
  background-color: ${vars.v3Color.gray200};
`;
